var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload-successful-screen" },
    [
      _c(
        "svg",
        {
          attrs: {
            width: "120",
            height: "120",
            viewBox: "0 0 120 120",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("g", { attrs: { "clip-path": "url(#clip0_6829_471)" } }, [
            _c("path", {
              attrs: {
                d:
                  "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
                fill: "white"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M60 113C89.2711 113 113 89.2711 113 60C113 30.7289 89.2711 7 60 7C30.7289 7 7 30.7289 7 60C7 89.2711 30.7289 113 60 113Z",
                stroke: "#D1D1D1",
                "stroke-width": "14"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M33 65.282L53.307 81.878",
                stroke: "#26C786",
                "stroke-width": "10",
                "stroke-linecap": "round"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M53.3071 81.878L87.5311 47.5",
                stroke: "#26C786",
                "stroke-width": "10",
                "stroke-linecap": "round"
              }
            })
          ]),
          _vm._v(" "),
          _c("defs", [
            _c("clipPath", { attrs: { id: "clip0_6829_471" } }, [
              _c("rect", {
                attrs: { width: "120", height: "120", fill: "white" }
              })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.$t("Account.UploadCenter.Success")))]),
      _vm._v(" "),
      !_vm.allFilesUploaded
        ? _c(
            "v-btn",
            {
              staticClass: "secondary-btn v-btn error",
              on: { click: _vm.addMoreFiles }
            },
            [_vm._v(_vm._s(_vm.$t("Account.UploadCenter.Success.AddMore")))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          staticClass: "primary-btn v-btn theme--light",
          on: { click: _vm.backToHome }
        },
        [_vm._v(_vm._s(_vm.$t("Account.UploadCenter.Success.Done")))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c3e0c7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c3e0c7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/UploadCenter/UploadSuccessfulScreen.vue
// module id = null
// module chunks = 